import React, { useEffect, useState } from "react";
import { CurrentQuotesWrap } from "./CompareQuoteStyled";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Tooltip,
  Typography,
} from "@mui/material";
import { Constants } from "./Content";
import { isJsonString } from "../../Helper/Helper";
import { LocalStorageKeys } from "../QuoteRequest/Content";
import { useDispatch } from "react-redux";
import { BundleToolTip } from "./Data";
import BundleOptionAccordian from "./BundleOptionAccordian";
import BundleOpportunityDetails from "./BundleOpportunityDetails";

const BundleQuotesAccordian = ({
  quotesToBundle,
  quoteHeaders,
  removeFromBundle,
  bundleOpportunity,
  bundleRevenue,
  removeBundleRevenue,
  showNotification,
}) => {
  const [quotesToBndle, setquotesToBndle] = useState(quotesToBundle);
  const [bundledQuotes, setBundledQuotes] = useState();
  const [bundleExpand, setBundleExpand] = useState([true, true, true]);

  const crmData = isJsonString(
    sessionStorage.getItem(LocalStorageKeys.CRMDATAINITIAL),
  )
    ? JSON.parse(sessionStorage.getItem(LocalStorageKeys.CRMDATAINITIAL))
    : "";
  let loggedUser = isJsonString(
    sessionStorage.getItem(LocalStorageKeys.LOGGEDUSER),
  )
    ? JSON.parse(sessionStorage.getItem(LocalStorageKeys.LOGGEDUSER))
    : null;
  const dispatch = useDispatch();

  useEffect(() => {
    setquotesToBndle(quotesToBundle);
    setBundledQuotes(quotesToBndle?.quotesForBundleDatas);
  }, [quotesToBundle]);

  const removeQuotes = (index) => {
    const tempBundle = [...quotesToBndle];
    tempBundle.splice(index, 1);
    setquotesToBndle(tempBundle);
    removeFromBundle(tempBundle);
    removeBundleRevenue(index);
    bundleAccordionClick(index);
  };

  const bundleAccordionClick = (index) => {
    const temp = bundleExpand;
    temp[index] = !temp[index];
    setBundleExpand([...temp]);
  };

  return (
    <CurrentQuotesWrap>
      {quotesToBndle?.length > 0 ? (
        <Accordion defaultExpanded>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon sx={{ color: "white" }} />}
            aria-controls="panel1-content"
            id="panel1-header"
            className="currentHeadingBox"
          >
            <div className="noBundleText">
              {Constants.BUNDLEDRATES}
              <Tooltip title={<span className="tooltip">{BundleToolTip}</span>}>
                <InfoOutlinedIcon />
              </Tooltip>
            </div>
          </AccordionSummary>
          <AccordionDetails className="bundleAccordion">
            <Box>
              <BundleOpportunityDetails
                opportunityDetails={bundleOpportunity}
              />
            </Box>
            <BundleOptionAccordian
              quoteHeaders={quoteHeaders}
              quotesToBndle={quotesToBndle}
              loggedUser={loggedUser}
              bundleRevenue={bundleRevenue}
              removeQuotes={removeQuotes}
              showNotification={showNotification}
              bundleExpanded={true}
            />
          </AccordionDetails>
        </Accordion>
      ) : (
        <Accordion disabled defaultExpanded>
          <AccordionSummary
            // expandIcon={<ExpandMoreIcon />}
            aria-controls="panel3-content"
            id="panel3-header"
          >
            <div className="noBundleText">
              <Typography>
                <strong>{Constants.BUNDLEDRATES}</strong>
              </Typography>
              <InfoOutlinedIcon />
              <Typography>
                <strong>{Constants.NOBUNDLETEXT1}</strong>
                {Constants.NOBUNDLETEXT2}
              </Typography>
            </div>
          </AccordionSummary>
        </Accordion>
      )}
    </CurrentQuotesWrap>
  );
};

export default BundleQuotesAccordian;
